export default {"src":"/_next/static/media/mastercard.922dc5f1.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};